module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('transition-group', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    key: "brand",
    staticClass: "modal-mask",
    attrs: {
      "id": "brand"
    }
  }, [_c('img', {
    staticClass: "cross fright abs pointer",
    attrs: {
      "src": require("../../../assets/croix.png"),
      "width": "20",
      "height": "20",
      "alt": ""
    },
    on: {
      "click": _vm.close
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-wrapper _modalWrapper_"
  }, [_c('div', {
    staticClass: "modal-container flexContainer"
  }, [_c('div', {
    staticClass: "modalBody"
  }, [_c('div', {
    staticClass: "modalContent txtCenter"
  }, [_c('h2', {
    staticClass: "ff-light"
  }, [_vm._v(_vm._s(_vm.$t("commentModal.title")))]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.commentContent),
      expression: "commentContent"
    }],
    attrs: {
      "id": "comment",
      "placeholder": "Comment"
    },
    domProps: {
      "value": (_vm.commentContent)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.commentContent = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div')]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn block pointer center",
    on: {
      "click": _vm.saveComment
    }
  }, [_vm._v(_vm._s(_vm.$t("commentModal.send")))])])])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6de95f1f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/plano/menu/ModalComment.vue
// module id = 3253
// module chunks = 0